/* Flooring Surgeons – delivery estimate (snippets/fs-delivery-estimate.liquid). No dependencies.
   Rule = the live WP site (read 4 Oct 2026, migration/policy/live-wp-snapshot-2026-10-04.md): "Order by 2pm for delivery by
   Thursday, 8 October". Earliest delivery = 3 WORKING days after the order day; an order placed after the cut-off counts from
   the next calendar day. Saturdays, Sundays and blocked dates (bank holidays, Christmas closure) never count.
   E.g. Mon before 2pm → Thu, Mon after 2pm → Fri, Fri any time → Wed, Sat → Wed, Sun before 2pm → Wed, Sun after 2pm → Thu
   (Thu → Tue, Sat → Wed and Sun evening → Thu were all seen on live). Reads Europe/London time with Intl, so it's right whatever the
   shopper's device timezone. Updates every minute. */
if (!customElements.get('fs-delivery-estimate')) {
  const partsNow = () => {
    const f = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
    });
    const p = Object.fromEntries(f.formatToParts(new Date()).map((x) => [x.type, x.value]));
    return { y: +p.year, m: +p.month, d: +p.day, h: +p.hour };
  };
  const iso = (dt) => dt.toISOString().slice(0, 10);
  const nice = new Intl.DateTimeFormat('en-GB', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' });
  // Live WP format: "Thursday, 8 October" (Intl en-GB gives "Thursday 8 October")
  const niceLive = (dt) => nice.format(dt).replace(/^(\w+) /, '$1, ');
  const short = new Intl.DateTimeFormat('en-GB', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' });

  /** Exposed for tests / other scripts: FSDelivery.estimate({ cutoff, before, after, blocked }, now?) */
  window.FSDelivery = {
    estimate({ cutoff = 14, before = 3, after = 3, blocked = [] } = {}, now = partsNow()) {
      /* Live WP rule: start = the order day, or the next calendar day when ordered at/after the cut-off; then count
         `before` (or `after`) WORKING days after the start (no Sat/Sun, no blocked dates). */
      const off = (d) => d.getUTCDay() === 0 || d.getUTCDay() === 6 || blocked.includes(iso(d));
      const dt = new Date(Date.UTC(now.y, now.m - 1, now.d));
      const beforeCutoff = now.h < cutoff;
      if (!beforeCutoff) dt.setUTCDate(dt.getUTCDate() + 1);
      for (let n = beforeCutoff ? before : after, i = 0; n > 0 && i < 60; i++) {
        dt.setUTCDate(dt.getUTCDate() + 1);
        if (!off(dt)) n -= 1;
      }
      return { date: dt, label: niceLive(dt), short: short.format(dt).replace(',', '').replace('Sept', 'Sep'), beforeCutoff };
    },
  };

  customElements.define(
    'fs-delivery-estimate',
    class extends HTMLElement {
      connectedCallback() {
        this.render();
        this.timer = setInterval(() => this.render(), 60000);
      }
      disconnectedCallback() {
        clearInterval(this.timer);
      }
      render() {
        const out = this.querySelector('[data-eta]');
        if (!out) return;
        const d = this.dataset;
        const cutoff = parseInt(d.cutoff, 10) || 14;
        let est;
        try {
          est = window.FSDelivery.estimate({
            cutoff,
            before: parseInt(d.before, 10) || 3,
            after: parseInt(d.after, 10) || 3,
            blocked: (d.blocked || '').split(',').map((s) => s.trim()).filter(Boolean),
          });
        } catch (e) {
          return; // keep the server fallback text
        }
        // Backorder (data-from = stock arrival date): no earlier than arrival + the after-cut-off lead time in working days
        if (d.from) {
          const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(d.from);
          if (m) {
            const blocked = (d.blocked || '').split(',').map((s) => s.trim()).filter(Boolean);
            const b = new Date(Date.UTC(+m[1], m[2] - 1, +m[3]));
            for (let n = 0; n < (parseInt(d.after, 10) || 3); ) {
              b.setUTCDate(b.getUTCDate() + 1);
              if (b.getUTCDay() !== 0 && b.getUTCDay() !== 6 && !blocked.includes(b.toISOString().slice(0, 10))) n++;
            }
            if (b > est.date) {
              out.textContent = '';
              const s2 = document.createElement('strong');
              s2.textContent = d.format === 'short' ? short.format(b).replace(',', '').replace('Sept', 'Sep') : niceLive(b);
              out.append('On backorder – order now for delivery from ', s2);
              return;
            }
          }
        }
        const time = cutoff === 12 ? '12 noon' : cutoff > 12 ? `${cutoff - 12}pm` : `${cutoff}am`;
        out.textContent = '';
        const strong = document.createElement('strong');
        // Live WP wording, the same whatever the time of day: "Order by 2pm for delivery by Thursday, 8 October"
        strong.textContent = d.format === 'short' ? est.short : est.label;
        out.append(`Order by ${time} for delivery by `);
        out.append(strong);
      }
    }
  );
}
